import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";

const getPaymentUrlSuccess = (data) => {
    return {
      type: actionTypes.GET_PAYMENT_URL,
      payload: data.Data, 
    };
  };
  

export const getPaymentUrl = (data) => async (dispatch) => {
    console.log("data",data);
    
  return await apiCall
    .axiosPost(`${API_BASE_URL}/GeneratePrivateClassPaymentLink`, data)
    .then((response) => {
      if (response) {
        dispatch(getPaymentUrlSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};